<template lang="html">
  <v-popover
    v-if="isMobile"
    container=".header-nav-content"
    placement="top-end"
  >
    <a class="hamburger" role="button">
      <font-awesome-icon :icon="['fas', 'bars']" />
    </a>

    <template slot="popover">
      <NavButtons v-close-popover class="in-popover" />
    </template>
  </v-popover>

  <NavButtons v-else />
</template>

<script>
import NavButtons from '@/components/NavButtons';
import mobileDetection from '@/mixins/mobile-detection';

export default {
  name: 'NavHamburger',

  components: {
    NavButtons,
  },

  mixins: [mobileDetection],
};
</script>

<style scoped lang="scss">
.hamburger {
  color: inherit;
  font-size: 1.5em;
}

.v-popover {
  display: flex;
}
</style>
